module.exports = __webpack_public_path__ + "img/bevfam_point_btn.5eb54c55.png";